// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./styles/block-hotspot-image.scss
// module id = 159
// module chunks = 9